import auth from "../middleware/auth";
import guest from "../middleware/guest";

export default [
  {
    path: "/settings/dashboard",
    name: "settings-dashboard",
    component: () => import("./../views/admin/Dashboard.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          active: true
        }
      ]
    },

    pageTitle: "Front",
    rule: "editor"
  },
  {
    path: "/settings/users",
    name: "settings",
    component: () => import("./../views/admin/Users.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Users",
          url: "/"
        },
        {
          title: "Настройки",
          i18n: 'settings'
        },
        {
          title: "Пользователи",
          i18n: "users",
          active: true
        }
      ]
    },

    pageTitle: "Front",
    rule: "editor"
  },

  {
    path: "/settings/permission",
    name: "permission",
    component: () => import("./../views/admin/Permission.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Permission",
          url: "/"
        },
        {
          title: "Настройки",
          i18n: 'settings'
        },
        {
          title: "Разрешение",
          i18n: "navmenu.settings.permission",
          active: true
        }
      ]
    },

    pageTitle: "Front",
    rule: "editor"
  },
  {
    path: "/settings/permission/:id",
    name: "settings_permission_id",
    component: () => import("../views/admin/UsersPermissions.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Users",
          url: "/"
        },
        {
          title: "Настройки",
          i18n: 'settings'
        },
        {
          title: "Разрешение",
          i18n: "navmenu.settings.permission",
          active: true
        }
      ]
    },

    pageTitle: "Front",
    rule: "editor"
  },
  {
    path: "/settings/users_role",
    name: "users-Role",
    component: () => import("./../views/admin/UsersRole.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Users",
          url: "/"
        },
        {
          title: "Настройки",
          i18n: 'settings'
        },
        {
          title: "Роли пользователей",
          active: true
        }
      ]
    },

    pageTitle: "Front",
    rule: "editor"
  },
  {
    path: "/settings/users_permissions/:role_id",
    name: "users-permission",
    component: () => import("./../views/admin/UsersPermissions.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Users",
          url: "/"
        },
        {
          url: "/settings/users",
          title: "Настройки",
          i18n: 'settings'
        },
        {
          url: "/settings/users_role",
          title: "Роли пользователей",
          active: false
        },
        {
          title: "Настройки ролей",
          active: true
        }
      ]
    },

    pageTitle: "Front",
    rule: "editor"
  },
  {
    path: '/settings/logs/index',
    name: 'settings-logs-index',
    component: () => import('@/views/admin/logging/index.vue'),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Users",
          url: "/"
        },
        {
          title: "Настройки",
          i18n: 'settings'
        },
        {
          title: "Журналирование",
          active: true
        }
      ],
    },
  },
  {
    path: '/settings/backups/index',
    name: 'settings-backups-index',
    component: () => import('@/views/admin/backups/index.vue'),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Users",
          url: "/"
        },
        {
          title: "Настройки",
          i18n: 'settings'
        },
        {
          title: "Пользователи",
          i18n: 'users',
          active: true
        }
      ],
    },

    pageTitle: "Front",
    rule: "editor"
  },
];
